import { ProgramNode } from "./ast";
import { getExpressionKeyPath } from "./expression";

export type Selection = {
  start: number;
  end: number;
};

type PropSelection = {
  start?: number | null;
  end?: number | null;
};

export const normalizeSelection = (selection: PropSelection): Selection => {
  let { start, end } = selection;

  if (start === undefined || start === null) {
    start = 0;
  } else if (end === undefined || end === null) {
    end = start;
  }

  start ??= 0;
  end ??= 0;

  if (start > end) {
    [start, end] = [end, start];
  }

  return { start, end };
};

export const getKeyPathFromSelection = (program: ProgramNode, selection: Selection): string[] | null => {
  const node = program.body.find((node) => node.start <= selection.start && node.end >= selection.end);

  if (node?.type !== "Expression") {
    return null;
  }

  return getExpressionKeyPath(node);
};
